import Vue from 'vue'
import Router from 'vue-router'

import Serials from './views/Serials.vue'
import Production from './views/Production.vue'
import Shipment from './views/Shipment.vue'
import DeliveryNote from './views/DeliveryNote.vue'
import Transfers from './views/Transfers'
import Inventory from './views/Inventory'
import InventoryAdmin from './views/InventoryAdmin'

import Home from './views/Home.vue'
import Login from './views/Login.vue'
import store from './store'


const onlyIfAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next('/login');
}

Vue.use(Router);

export default new Router({
  routes: [
      {
          path: '/login',
          component: Login
      },
      {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: onlyIfAuthenticated,
      },
      {
        path: '/serials',
        name: 'Serials',
        component: Serials,
        beforeEnter: onlyIfAuthenticated,
      },
      {
          path: '/produced',
          name: 'Production',
          component: Production,
          beforeEnter: onlyIfAuthenticated,
      },
      {
          path: '/shipped',
          name: 'Shipment',
          component: Shipment,
          beforeEnter: onlyIfAuthenticated,
      },
      {
          path: '/deliverynote',
          name: 'Delivery Note',
          component: DeliveryNote,
          beforeEnter: onlyIfAuthenticated,
      },{
          path: '/transfers',
          name: 'Transfers',
          component: Transfers,
          beforeEnter: onlyIfAuthenticated,
      },{
          path: '/inventory',
          name: 'Inventory',
          component: Inventory,
          beforeEnter: onlyIfAuthenticated,
      },{
          path: '/inventory-admin',
          name: 'Inventory Admin',
          component: InventoryAdmin,
          beforeEnter: onlyIfAuthenticated,
      },

  ]
})
